var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-pagination-nav',{attrs:{"size":"md","value":_vm.page,"link-gen":_vm.linkGen,"limit":_vm.pageLimit,"number-of-pages":_vm.numberOfPages,"no-page-detect":true},on:{"input":_vm.pageChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }